/* eslint-disable */

function loadScript(url) {
  var scriptElement = document.createElement('script');
  scriptElement.src = url;
  document.getElementsByTagName('body')[0].appendChild(scriptElement);
  return scriptElement;
}

/**
 * Element.closest() polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 */
if (!Element.prototype.closest) {
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  }
  Element.prototype.closest = function(s) {
    var el = this;
    var ancestor = this;
    if (!document.documentElement.contains(el)) return null;
    do {
      if (ancestor.matches(s)) return ancestor;
      ancestor = ancestor.parentElement;
    } while (ancestor !== null);
    return null;
  };
}

(function() {
  if (typeof window.CustomEvent === 'function') return false;

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: null };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  window.CustomEvent = CustomEvent;
})();

var event = document.createEvent('Event');
event.initEvent('icisAppReady', true, true);

(function() {
  if (
    'startsWith' in String.prototype &&
    'endsWith' in String.prototype &&
    'includes' in Array.prototype &&
    'assign' in Object &&
    'keys' in Object &&
    'fetch' in window &&
    typeof Object.values === 'function'
  ) {
    window.icisAppReady = true;
    window.dispatchEvent(event);
    loadScript(window.icisAppConfig.appScript);
    return;
  }

  var polyFillScriptElement = loadScript(window.icisAppConfig.polyfillScript);
  polyFillScriptElement.onload = function() {
    window.icisAppReady = true;
    window.dispatchEvent(event);
    loadScript(window.icisAppConfig.appScript);
  };
})();
